"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
exports.default = CompanyMenu;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_2 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const ServiceTeamContact_1 = __importDefault(require("./ServiceTeamContact"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const SingleSignOn_1 = require("../shared/SingleSignOn");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const UserContext_1 = require("../contexts/UserContext");
const AdminContext_1 = require("../contexts/AdminContext");
exports.Routes = {
    'CompanyEmployeeDetail': {
        blankBeforeNavigate: true,
        prismUrl: (r, ctx) => '/uex/#/ess/manager/employees/details?employeeId=' + r?.employeeId,
        checkAccess: (ctx) => (ctx?.isPrismManager?.())
    },
    'CompanyApprovals': {
        prismUrl: () => '/uex/#/ess/manager/approvals/pending',
        checkAccess: (ctx) => (ctx?.isPrismManager?.())
    },
    'CompanyPayrollProcess': {
        prismUrl: (r, ctx) => {
            var selfService = ctx?.isPrismManager?.() &&
                ctx?.hasPrismHrRole?.('PRP') &&
                ctx?.hasPrismProcess?.('HRPY.WORK*PAYROLL.PROCESSING');
            var isSelfServiceClient = typeof ctx?.isSelfServiceClient === 'function'
                ? ctx.isSelfServiceClient()
                : Boolean(ctx?.isSelfServiceClient);
            if (selfService === true && isSelfServiceClient)
                return '/uex/#/ess/manager/process-payroll';
            return '/uex/#/ess/manager/timesheet-entry';
        },
        checkAccess: (ctx) => {
            if (ctx?.isPrismManager?.() === false)
                return false;
            var isSelfServiceClient = typeof ctx?.isSelfServiceClient === 'function'
                ? ctx.isSelfServiceClient()
                : Boolean(ctx?.isSelfServiceClient);
            if (isSelfServiceClient)
                return ctx?.hasPrismHrRole?.('PRP') &&
                    ctx?.hasPrismProcess?.('HRPY.WORK*PAYROLL.PROCESSING');
            return (ctx?.hasPrismHrRole?.('TSE') || ctx?.hasPrismHrRole('TSR')) &&
                ctx?.hasPrismProcess?.('HRP.TIME.SHEETS*MAINT');
        }
    },
    'CompanyPayrollApproval': {
        prismUrl: () => '/uex/#/ess/manager/payroll-approvals',
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.hasPrismHrRole?.('PRA') &&
            ctx?.hasPrismProcess?.('HRPY.WORK*PAYROLL.APPROVAL'))
    },
    'CompanyPayrollHistory': {
        prismUrl: () => '/uex/#/ess/manager/payroll-history',
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.hasPrismProcess?.('HRPY.WORK*PAYROLL.HISTORY'))
    },
    'CompanyDocuments': {
        prismUrl: () => '/uex/#/ess/manager/documents',
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.data?.prismEmployeeStatus == 'A')
    },
    'CompanyApplicantTracking': {
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.hasPrismProcess?.('HRPY.WORK*HTG'))
    },
    'CompanyEVerify': {
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.hasPrismProcess?.('HRPY.WORK*CUSTOM.HRWC'))
    },
    'CompanyScreening': {
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.hasPrismProcess?.('HRPY.WORK*CUSTOM.CRIMCHECK'))
    },
    'CompanyReports': {
        prismUrl: () => '/uex/#/ess/manager/reports',
        checkAccess: (ctx) => (ctx?.isPrismManager?.())
    },
    'CompanyReportCenter': {
        blankBeforeNavigate: true,
        prismUrl: () => '/apis/ep/sso/report-center-new',
        checkAccess: (ctx) => (ctx?.isPrismManager?.() &&
            ctx?.hasPrismProcess?.('HRPY.WORK*SIGRC'))
    }
};
const CompanyMenuItem = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const adminContext = react_1.default.useContext(AdminContext_1.AdminContext);
    let currentState = props.navigation?.getState();
    let currentCount = currentState?.routes?.length;
    let currentRoute = currentState?.routes?.[currentCount - 1]?.name;
    let selected = (currentRoute == props.route) ||
        (props.select?.includes?.(currentRoute));
    return ((0, jsx_runtime_1.jsx)(react_native_2.Pressable, { onPress: () => {
            props.onPress?.();
            if (props.route) {
                if (currentRoute == props.route) {
                    props.navigation?.replace(props.route);
                }
                else {
                    if (exports.Routes[props.route]?.blankBeforeNavigate == true) {
                        adminContext?.navigate(null);
                    }
                    props.navigation?.navigate(props.route);
                }
            }
        }, style: ({ pressed }) => [
            {
                paddingHorizontal: 10,
                paddingVertical: 8,
                borderRadius: 2,
                backgroundColor: selected ? THEME.Secondary + '33' : null,
                borderLeftColor: selected ? THEME.Secondary : 'transparent',
                borderLeftWidth: 6,
                userSelect: 'none'
            },
            (pressed ? {
                backgroundColor: selected ? THEME.Secondary + '44' : THEME.Secondary + '22'
            } : null)
        ], children: (0, jsx_runtime_1.jsxs)(react_native_2.View, { style: { flexDirection: 'row', alignItems: 'center', gap: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: 20, style: { color: THEME.Text, pointerEvents: 'none', outlineWidth: 0 } }), (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { flex: 1, color: THEME.Text, fontSize: 16, fontWeight: '500' }, children: props.text }), props.external &&
                    (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, size: 14, style: { color: THEME.Text, pointerEvents: 'none', outlineWidth: 0, marginTop: -1 } })] }) }));
};
const CompanyMenuContent = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const featureTA = userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance');
    return ((0, jsx_runtime_1.jsxs)(react_native_2.ScrollView, { style: { padding: 12 }, contentContainerStyle: {
            flexDirection: 'column',
            gap: (react_native_1.Platform.OS == 'web' ? 2 : 0),
            paddingBottom: (react_native_1.Platform.OS === 'android' ? 16 : undefined)
        }, children: [(0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "Company", text: t('common:screenTitles.dashboard'), icon: Theme_1.ICONS.Regular.Apartment, navigation: props.navigation }), props.context?.status == 'loading' &&
                (0, jsx_runtime_1.jsx)(react_native_2.View, { style: { paddingVertical: 12, backgroundColor: THEME.LightGray + '88', borderRadius: 2, marginVertical: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_2.ActivityIndicator, { color: THEME.Primary, size: 32 }) }), props.context?.isPrismManager?.() &&
                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyEmployees", select: ["CompanyEmployeeDetail"], text: t('common:screenTitles.employees'), icon: Theme_1.ICONS.Regular.Users, navigation: props.navigation }), exports.Routes['CompanyApprovals'].checkAccess(props.context) &&
                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyApprovals", text: t('common:screenTitles.myApprovals'), icon: Theme_1.ICONS.Regular.CalendarCheck, navigation: props.navigation }), !userContext.isImpersonated &&
                !!featureTA?.isEnabled &&
                ['timeco', 'kronos'].includes(featureTA?.vendor?.toLowerCase())
                &&
                    (0, jsx_runtime_1.jsx)(CompanyMenuItem, { external: true, text: t('common:screenTitles.ta'), icon: Theme_1.ICONS.Regular.Clock, navigation: props.navigation, onPress: () => {
                            let provider = featureTA?.vendor?.toLowerCase();
                            let feature = null;
                            if (provider === 'kronos')
                                feature = 'Kronos SSO';
                            if (provider === 'timeco')
                                feature = 'TimeCo SSO';
                            if (feature) {
                                FirebaseAnalytics_1.default.LogEvent('feature_used', {
                                    feature: feature,
                                    client: userContext?.client?.id,
                                    employee: userContext?.employee?.employeeId
                                });
                            }
                            SingleSignOn_1.SingleSignOn.Perform({
                                navigation: props.navigation,
                                client: userContext?.client?.id,
                                provider: provider,
                                title: t('common:screenTitles.ta'),
                                forceMobileWeb: react_native_1.Platform.OS == 'web'
                            });
                        } }), exports.Routes['CompanyApplicantTracking'].checkAccess(props.context) &&
                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { external: true, text: t('common:screenTitles.applicantTracking'), icon: Theme_1.ICONS.Solid.RectangleHistoryCircleUser, navigation: props.navigation, onPress: () => {
                        FirebaseAnalytics_1.default.LogEvent('feature_used', {
                            feature: 'Prism SSO - Applicant Tracking',
                            client: userContext.client?.id,
                            employee: userContext.employee?.employeeId
                        });
                        SingleSignOn_1.SingleSignOn.Perform({
                            navigation: props.navigation,
                            client: userContext?.client?.id,
                            provider: 'prismfeature',
                            title: t('common:screenTitles.applicantTracking'),
                            additionalRouting: 'HTG'
                        });
                    } }), exports.Routes['CompanyEVerify'].checkAccess(props.context) &&
                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { external: true, text: t('common:screenTitles.eVerify'), icon: Theme_1.ICONS.Solid.ShieldCheck, navigation: props.navigation, onPress: () => {
                        FirebaseAnalytics_1.default.LogEvent('feature_used', {
                            feature: 'Prism SSO - E-Verify',
                            client: userContext.client?.id,
                            employee: userContext.employee?.employeeId
                        });
                        SingleSignOn_1.SingleSignOn.Perform({
                            navigation: props.navigation,
                            client: userContext?.client?.id,
                            provider: 'prismfeature',
                            title: t('common:screenTitles.eVerify'),
                            additionalRouting: 'HRWC'
                        });
                    } }), exports.Routes['CompanyScreening'].checkAccess(props.context) &&
                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { external: true, text: t('common:screenTitles.screening'), icon: Theme_1.ICONS.Solid.FileCircleCheck, navigation: props.navigation, onPress: () => {
                        FirebaseAnalytics_1.default.LogEvent('feature_used', {
                            feature: 'Prism SSO - Screening Services',
                            client: userContext.client?.id,
                            employee: userContext.employee?.employeeId
                        });
                        SingleSignOn_1.SingleSignOn.Perform({
                            navigation: props.navigation,
                            client: userContext?.client?.id,
                            provider: 'prismfeature',
                            title: t('common:screenTitles.screening'),
                            additionalRouting: 'Crimcheck'
                        });
                    } }), (exports.Routes['CompanyPayrollProcess'].checkAccess(props.context) ||
                exports.Routes['CompanyPayrollApproval'].checkAccess(props.context) ||
                exports.Routes['CompanyPayrollHistory'].checkAccess(props.context))
                &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                    padding: 6, paddingLeft: 8,
                                    backgroundColor: THEME.LightGray,
                                    borderRadius: 2, marginVertical: 4
                                }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 13, fontWeight: '500', userSelect: 'none' }, children: "PAYROLL" }) }), exports.Routes['CompanyPayrollProcess'].checkAccess(props.context) &&
                                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyPayrollProcess", text: t('common:screenTitles.processPayroll'), icon: Theme_1.ICONS.Regular.MoneyCheckDollarPen, navigation: props.navigation }), exports.Routes['CompanyPayrollApproval'].checkAccess(props.context) &&
                                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyPayrollApproval", text: t('common:screenTitles.payrollApproval'), icon: Theme_1.ICONS.Regular.ClipboardCheck, navigation: props.navigation }), exports.Routes['CompanyPayrollHistory'].checkAccess(props.context) &&
                                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyPayrollHistory", text: t('common:screenTitles.payrollHistory'), icon: Theme_1.ICONS.Solid.Dollar, navigation: props.navigation })] }), (exports.Routes['CompanyDocuments'].checkAccess(props.context) ||
                exports.Routes['CompanyReports'].checkAccess(props.context) ||
                exports.Routes['CompanyReportCenter'].checkAccess(props.context))
                &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                                    padding: 6, paddingLeft: 8,
                                    backgroundColor: THEME.LightGray,
                                    borderRadius: 2, marginVertical: 4
                                }, children: (0, jsx_runtime_1.jsx)(react_native_2.Text, { style: { color: THEME.Text, fontSize: 13, fontWeight: '500', userSelect: 'none' }, children: "DOCUMENTS & REPORTS" }) }), exports.Routes['CompanyDocuments'].checkAccess(props.context) &&
                                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyDocuments", text: t('common:screenTitles.documents'), icon: Theme_1.ICONS.Regular.FileLines, navigation: props.navigation }), exports.Routes['CompanyReports'].checkAccess(props.context) &&
                                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanyReports", text: t('common:screenTitles.reports'), icon: Theme_1.ICONS.Solid.ChartMixed, navigation: props.navigation }), exports.Routes['CompanyReportCenter'].checkAccess(props.context) &&
                                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { external: true, text: "Report Center", icon: Theme_1.ICONS.Regular.DisplayChartUp, navigation: props.navigation, onPress: () => {
                                        FirebaseAnalytics_1.default.LogEvent('feature_used', {
                                            'feature': 'Prism SSO - Reports Center',
                                            'client': userContext.client?.id,
                                            'employee': userContext.employee?.employeeId
                                        });
                                        SingleSignOn_1.SingleSignOn.Perform({
                                            navigation: props.navigation,
                                            client: userContext?.client?.id,
                                            provider: 'prism',
                                            title: t('common:screenTitles.reports'),
                                            autoNavigate: 'reportcenter'
                                        });
                                    } })] }), (0, jsx_runtime_1.jsx)(react_native_2.View, { style: {
                    padding: 3,
                    backgroundColor: THEME.LightGray,
                    borderRadius: 2, marginVertical: 4
                } }), (0, jsx_runtime_1.jsx)(CompanyMenuItem, { route: "CompanySettings", text: t('common:screenTitles.settings'), icon: Theme_1.ICONS.Regular.Gear, navigation: props.navigation }), (0, jsx_runtime_1.jsx)(ServiceTeamContact_1.default, { renderTrigger: (open) => ((0, jsx_runtime_1.jsx)(CompanyMenuItem, { text: t('common:screenTitles.contactUs'), icon: Theme_1.ICONS.Regular.Envelope, navigation: props.navigation, onPress: () => {
                        react_native_1.DeviceEventEmitter.emit('event.hideCompanyMenu');
                        open();
                    } })) }), userContext?.adminExperience == 'both' &&
                (0, jsx_runtime_1.jsx)(CompanyMenuItem, { external: true, text: "Company Admin", icon: Theme_1.ICONS.Regular.ScrewdriverWrench, navigation: props.navigation, onPress: () => {
                        FirebaseAnalytics_1.default.LogEvent('feature_used', {
                            'feature': 'Prism SSO - Company Admin',
                            'client': userContext.client?.id,
                            'employee': userContext.employee?.employeeId
                        });
                        SingleSignOn_1.SingleSignOn.Perform({
                            navigation: props.navigation,
                            client: userContext?.client?.id,
                            provider: 'prismfeature',
                            title: t('common:appmenus.companyAdmin')
                        });
                    } })] }));
};
const CompanyMenuAnimated = (props) => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const blur = react_1.default.useRef(null);
    const menuVisible = react_1.default.useRef(false);
    const menuLeft = react_1.default.useRef(new react_native_1.Animated.Value(-props.size.width)).current;
    const [overlayVisible, setOverlayVisible] = react_1.default.useState(false);
    const overlayOpacity = react_1.default.useRef(new react_native_1.Animated.Value(0)).current;
    const showMenu = (callback = null) => {
        if (props.float) {
            menuVisible.current = true;
            react_native_1.Animated.timing(menuLeft, {
                toValue: 0,
                duration: 200,
                useNativeDriver: true
            }).start(() => {
                callback?.();
            });
            react_native_1.Animated.timing(overlayOpacity, {
                toValue: 1,
                duration: 200,
                useNativeDriver: true
            }).start();
            setOverlayVisible(true);
        }
    };
    const hideMenu = (callback = null) => {
        if (props.float) {
            menuVisible.current = false;
            react_native_1.Animated.timing(menuLeft, {
                toValue: -props.size.width,
                duration: 200,
                useNativeDriver: true
            }).start(() => {
                callback?.();
            });
            react_native_1.Animated.timing(overlayOpacity, {
                toValue: 0,
                duration: 200,
                useNativeDriver: true
            }).start(() => setOverlayVisible(false));
        }
    };
    react_1.default.useEffect(() => {
        const toggleListener = react_native_1.DeviceEventEmitter.addListener('event.toggleCompanyMenu', () => (menuVisible.current) ? hideMenu() : showMenu());
        const hideListener = react_native_1.DeviceEventEmitter.addListener('event.hideCompanyMenu', () => hideMenu());
        return () => {
            toggleListener?.remove();
            hideListener?.remove();
        };
    }, []);
    react_1.default.useEffect(() => {
        blur.current?.();
        blur.current = props.navigation?.addListener('blur', () => hideMenu());
        return () => blur.current?.();
    }, [props.navigation]);
    if (props.float && props.size?.height == 0)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.float &&
                (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: {
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        top: props.size.top,
                        height: props.size.height,
                        backgroundColor: '#00000033',
                        opacity: overlayOpacity,
                        display: (overlayVisible ? 'flex' : 'none'),
                        // @ts-ignore
                        userSelect: 'none'
                    }, children: (0, jsx_runtime_1.jsx)(react_native_2.Pressable, { onPress: () => hideMenu(), style: { flex: 1, cursor: 'auto' } }) }), (0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: [
                    {
                        width: props.size.width,
                        height: '100%',
                        backgroundColor: THEME.ScreenBackground,
                        borderRightColor: THEME.TabBorder,
                        borderRightWidth: 1,
                    },
                    props.float && {
                        position: 'absolute',
                        transform: [{ translateX: menuLeft }],
                        top: props.size.top,
                        bottom: 0,
                        left: 0,
                        height: react_native_1.Platform.OS === 'android' ? props.size.height + 4 : props.size.height,
                    }
                ], children: (0, jsx_runtime_1.jsx)(CompanyMenuContent, { float: props.float, context: props.context, navigation: props.navigation }) })] }));
};
function CompanyMenu(props) {
    const safe = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const adminContext = react_1.default.useContext(AdminContext_1.AdminContext);
    const viewRef = react_1.default.useRef(null);
    const [size, setSize] = react_1.default.useState({ width: 250, height: 0, top: 0 });
    react_1.default.useLayoutEffect(() => {
        viewRef.current?.measure?.((x, y, w, h, px, py) => {
            setSize({ ...size, height: (h - safe.top), top: (py + safe.top) });
        });
    }, []);
    react_1.default.useEffect(() => {
        if (react_native_1.Platform.OS == 'web') {
            let resizeHandler = () => {
                viewRef.current?.measure?.((x, y, w, h, px, py) => {
                    setSize({ ...size, height: h, top: py });
                });
            };
            window.addEventListener('resize', resizeHandler);
            return () => {
                window.removeEventListener('resize', resizeHandler);
            };
        }
    }, []);
    const menu = react_1.default.useMemo(() => ((0, jsx_runtime_1.jsx)(CompanyMenuAnimated, { size: size, float: adminContext?.floatMenu, context: adminContext, navigation: props.navigation })), [size, adminContext, props.navigation]);
    react_1.default.useEffect(() => {
        adminContext?.setMenu(adminContext?.floatMenu ? menu : null);
        return () => adminContext?.setMenu(null);
    }, [menu]);
    return ((0, jsx_runtime_1.jsx)(react_native_2.View, { ref: viewRef, children: adminContext?.floatMenu ? null : menu }));
}
